import React, { useState } from 'react';
import moment from 'moment';

import useGlobal from '../../../../store';
import SearchInput from '../../../../facturotopia/search-input/SearchInput';
import CalendarDateRangePicker from '../../../../facturotopia/calendar-date-range-picker/CalendarDateRangePicker.jsx';

const mapState = (store) => {
  return {
    audits: store.developer.stamping.comprobantes,
  };
};

const mapActions = (actions) => {
  return { ...actions.developer.stamping.comprobantes };
};

const TimbradoComprobanteSearch = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);

  const from = moment().subtract(7, 'days').toDate();
  const to = moment().toDate();

  const [date, setDate] = useState([from, to]);

  const { filters } = state.audits;

  const handleOnKeywordChange = (keyword) => {
    actions.paginate({
      ...filters,
      search: keyword,
    });
  };

  const handleOnSearchClear = () => {
    handleOnKeywordChange('');
  };

  const handleOnDateChange = (date) => {
    const from = moment(date[0]);
    const to = moment(date[1]);

    setDate(date);

    actions.paginate({
      ...filters,
      page: 1,
      from: from.format('YYYY-MM-DD'),
      to: to.format('yyyy-MM-DD'),
    });
  };

  const { search } = filters;

  return (
    <div className="d-flex flex-column flex-sm-row">
      <div className="d-flex flex-column flex-sm-row">
        <div className="pr-2 pb-2">
          <CalendarDateRangePicker
            value={date}
            onDateChange={handleOnDateChange}
          />
        </div>
        <div className="flex-fill search-container">
          <SearchInput
            onKeywordChange={handleOnKeywordChange}
            onClear={handleOnSearchClear}
            value={search}
          />
        </div>
      </div>
    </div>
  );
};

export default TimbradoComprobanteSearch;
